<!-- 账号管理 -->
<style scoped>
</style>
<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <a-form-model :rules="rules" ref="formModel" size="small" :model="form">
        <a-form-model-item label="类型">
          <span>{{ typeLabel }}</span>
        </a-form-model-item>
        <template v-if="isBookingMonth">
          <a-form-model-item label="发货月份" prop="content">
            <a-input-number
              v-model="shipMonth"
              :min="1"
              :max="12"
              :precision="0"
              placeholder="1-12"
            />
            <span style="margin-left: 8px">月</span>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" :loading="submitLoading" @click="onSubmit">
              保存
            </a-button>
          </a-form-model-item>
        </template>
        <template v-else>
          <a-form-model-item label="说明内容">
            <div class="w-100">
              <wangeditor
                v-if="isShow"
                ref="editor"
                @change="editorChange"
                :content="form.content"
              ></wangeditor>
            </div>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" :loading="submitLoading" @click="onSubmit">
              保存
            </a-button>
          </a-form-model-item>
        </template>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import wangeditor from "@/components/wangeditor.vue";
import { setting_updateSysDescMember } from "@/api/config";

const BOOKING_MONTH_CNAME = "booking_month";

export default {
  components: { wangeditor },
  props: {
    obj: Object,
  },
  data() {
    return {
      IMGHOST: window.IMGHOST,
      ajaxparams: {}, //请求参数
      /*
			列表header
		*/
      levels: {
        sys_desc_member_vip: "vip",
        sys_desc_member_A1: "A1",
        sys_desc_member_A2: "A2",
        sys_desc_member_A3: "A3",
        sign_rule: "签到规则",
      },

      submitLoading: false,
      form: {
        type: this.obj.cname,
        content: this.obj.content,
      },
      rules: {},
      isShow: false,
      shipMonth: 6,
    };
  },
  computed: {
    isBookingMonth() {
      return this.form.type === BOOKING_MONTH_CNAME;
    },
    typeLabel() {
      return (
        this.levels[this.form.type] ||
        (this.obj && this.obj.remark) ||
        this.form.type
      );
    },
  },
  created() {
    const isBook = this.obj.cname === BOOKING_MONTH_CNAME;
    const raw = this.stripHtml(this.obj.cvalue);
    const n = parseInt(raw, 10);
    this.shipMonth =
      isBook && !Number.isNaN(n) && n >= 1 && n <= 12 ? n : 6;
    this.form = {
      type: this.obj.cname,
      content: isBook
        ? this.wrapBookingHtml(this.shipMonth)
        : this.obj.cvalue,
    };
    if (!isBook) {
      setTimeout(() => {
        this.isShow = true;
      }, 100);
    }
  },
  mounted() {},
  methods: {
    stripHtml(val) {
      if (val == null || val === "") return "";
      return String(val)
        .replace(/<[^>]+>/g, "")
        .trim();
    },
    wrapBookingHtml(month) {
      return `<p>${month}</p>`;
    },
    editorChange(html) {
      this.form.content = html;
    },

    async onSubmit() {
      if (this.isBookingMonth) {
        this.form.content = this.wrapBookingHtml(this.shipMonth);
      }
      this.$refs.formModel.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          setting_updateSysDescMember(this.form)
            .then((result) => {
              this.$message.success("操作成功");
              this.$emit("submit");
              this.submitLoading = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
